<upload-file-extensions-tooltip>

    <div class="tooltip tooltip-{props.position || 'left'}" data-tip="">
        <span class="tooltip-content w-84 text-xs">
            {locale?.t('upload_supportedfiletypes')} {getAcceptedFileTypes()}
        </span>
        <i class="icon-info1 text-gray-500 text-xl"></i>
    </div>

    <script>
        import { values } from '../services/values.js';

        export default {
            // Human-readable list of accepted upload extensions for the tooltip.
            // A few internal-only extensions are omitted from the display.
            getAcceptedFileTypes() {
                const omittedTypes = ['.rtf', '.amr', '.flac', '.ogg', '.webm', '.m4a'];
                return values.acceptedFiles
                    .filter(file => !omittedTypes.includes(file))
                    .map(file => {
                        const upperFile = file.toUpperCase();
                        if (upperFile === '.ZIP') {
                            return upperFile + ' (SCORM, xAPI, cmi5)';
                        }
                        return upperFile;
                    })
                    .join(', ');
            }
        }
    </script>
</upload-file-extensions-tooltip>
